import ThemedComponent from '../../hoc/ThemedComponent';

import { default as OffersFilterDefault } from './OffersFilter/View';
import { default as OffersFilter3 } from '../../themes/3/components/Offers/OffersFilter';
import { default as OffersListDefault } from './OffersList';
import { default as OffersList4 } from '../../themes/4/components/Offers/OffersList';
import { default as OffersListItemDefault } from './OffersListItem';
import { default as OffersListItem4 } from '../../themes/4/components/Offers/OffersListItem';

const ThemedOffersFilter = {
  default: OffersFilterDefault,
  // 3: OffersFilter3,
};
const ThemedOffersList = {
  default: OffersListDefault,
  // 4: OffersList4,
};
const ThemedOffersListItem = {
  default: OffersListItemDefault,
  // 4: OffersListItem4,
};

export const OffersFilterView = ThemedComponent(ThemedOffersFilter);

export const OffersList = ThemedComponent(ThemedOffersList);

export const OffersListItem = ThemedComponent(ThemedOffersListItem);

